module.exports = __webpack_public_path__ + "img/KinokoTable17.54ef36d0.jpg";